module.exports = __webpack_public_path__ + "static/media/image4.a54a83ba.jpg";